var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('p',{staticClass:"last-modify"},[_vm._v("最后更新时间："+_vm._s(_vm.lastModifyTime))]),_c('templ-pure',{attrs:{"renderData":_vm.renderData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }